// =============================
// Turnstile Constants
// =============================
// --- Actions ---
var ACTIONS = {
    PARENT_SIGNUP_FORM: "PARENT_SIGNUP_FORM",
};
// --- Events ---
var EVENTS = {
    SCRIPT_NOT_LOADED: "Turnstile script not loaded",
    VALIDATION_FAILED: "Validation failed using turnstile",
    VALIDATION_SUCCESS: "Validation success using turnstile",
    WIDGET_NOT_SUPPORTED: "Turnstile widget not supported in browser",
};
// --- Event Properties ---
var EVENT_PROPS = {
    CHALLENGE_ERROR: "challenge_error",
    CHALLENGE_SUCCESS: "challenge_success",
    ONERROR_CALLBACK: "onerror_callback",
    ONLOAD_CALLBACK: "onload_callback",
    CTA_CLICK: "cta_click",
    TIMEOUT: "timeout",
};
// --- User Types ---
var USER_TYPES = {
    PARENT: "parent",
    UNVERIFIED: "unverified_user",
};
// --- Error Codes ---
var ERROR_CODES = {
    WIDGET_UNSUPPORTED: "turnstile_widget_unsupported",
    TOKEN_EXPIRED: "cf_token_expired",
};
// --- Unified Export ---
export var Turnstile = {
    ACTIONS: ACTIONS,
    EVENTS: EVENTS,
    EVENT_PROPS: EVENT_PROPS,
    USER_TYPES: USER_TYPES,
    ERROR_CODES: ERROR_CODES,
};
